import apiEndPoints from "../../utils/apiEndPoints";//added cp approve service 
import { apiCall } from "../../utils/httpClient";
import { getDatabase, ref, set, onValue, push, update } from "firebase/database";
import firebaseService from "utils/firebaseConfig";

const fireData = (data) => {
  const database = getDatabase(firebaseService.firebaseApp);
  let login_id = data?.login_id
  const dbRef = ref(database, `cplogout/${login_id}`);

  update(dbRef, {
    firelogin: data.status,
    login_id: login_id,
  }).then(() => {
    console.log("Data saved successfully!",login_id);
  }).catch((error) => {
    console.error("Error saving data:", error);
  });
};

const channelPartnerList = async (params) => {
  const data = await apiCall("post", apiEndPoints.CHANNELPARTNERLIST, params);
  return data;
};
const channelPartnerDetail = async (params) => {
  const data = await apiCall("post", apiEndPoints.CHANNELPARTNERDETAIL, params);
  return data;
};
const channelPartnerFilter = async (params) => {
  const data = await apiCall("post", apiEndPoints.CHANNELPARTNERFILTER, params);
  return data;
};
const getAssignCPList = async (params) => {
  const data = await apiCall("post", apiEndPoints.CPASSIGNFILTER, params);
  return data;
};
const getEmployeeList = async (params) => {
  const data = await apiCall("post", apiEndPoints.CPEMPLOYEE, params);
  return data;
};
const channelPartnerStatusUpdate = async (params) => {
  const data = await apiCall("post", apiEndPoints.CHANNELPARTNERSTATUS, params);
  return data;
};
const addChannelPartner = async (params) => {
  const data = await apiCall("post", apiEndPoints.ADDCHANNELPARTNER, params, {
    "Content-Type": "application/x-www-form-urlencoded",
  });
  return data;
};
const getSMlist = async (params) => {
  const data = await apiCall("post", apiEndPoints.GETSMLIST, params);
  return data;
};
const checkEmailMobile = async (params) => {
  const data = await apiCall("post", apiEndPoints.CHECKEMAILMOBILE, params);
  return data;
};
const cpCurrentMaping = async (params) => {
  const data = await apiCall("post", apiEndPoints.CPCURRENTMAPING, params);
  return data;
};
const channelPartnerApprove = async(params)=>{
  const data = await apiCall("post",apiEndPoints.CHANNELPARTNERAPPROVE,params)
  return data 
}

const addCpToBucket = async(params)=>{
  const data = await apiCall("post",apiEndPoints.ADDCPTOBUCKET,params)
  return data 
}

const updateChannelPartner = async (params) => {
  const data = await apiCall("post", apiEndPoints.UPDATECHANNELPARTNER, params, {
    "Content-Type": "application/x-www-form-urlencoded",
  });
  return data;
};

const getCplistForSm =async (params) => {
  const data = await apiCall("post", apiEndPoints.CPLISTFORSM, params);
  return data;
};

const channelPartnerService = {
  channelPartnerList,
  channelPartnerDetail,
  channelPartnerFilter,
  channelPartnerStatusUpdate,
  addChannelPartner,
  getSMlist,
  checkEmailMobile,
  cpCurrentMaping,
  fireData,
  channelPartnerApprove,
  getAssignCPList,
  getEmployeeList,
  addCpToBucket,
  updateChannelPartner,
  getCplistForSm
};

export default channelPartnerService;
